export const isInIFrame = () => {
  try {
    return window !== window.top;
  } catch (e) {
    return true;
  }
};